(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-media-content')) {
    customElements.define(
      'product-media-content',
      class ProductMediaContent extends HTMLElement {
        connectedCallback() {
          const footer = this.querySelector('.product-information__media-footer');
          if (!footer) return;

          this.observer = new ResizeObserver(() => {
            this.style.setProperty('--media-footer-height', `${footer.offsetHeight}px`);
            this.style.setProperty('--media-content-height', `${this.offsetHeight}px`);
          });
          this.observer.observe(footer);
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
